import React, {
  createContext,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useAuth } from "../hooks/useAuth";
import { useHttp } from "../hooks/useHttp";
import { API_URLS, DEFAULT_HEADERS } from "../util/constants";
import { handleApiError } from "../util/errorHandler";

export const MyAccountContext = createContext({});

export const MyAccountProvider = ({ children }) => {
  const { user } = useAuth();
  const { sendRequest } = useHttp();

  const [userData, setUserData] = useState();
  const [companyData, setCompanyData] = useState();
  const [contactTerra, setContactTerra] = useState();
  const [collaborators, setCollaborators] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [paymentDelivery, setPaymentDelivery] = useState();
  const [orderTargetCompanies, setOrderTargetCompanies] = useState([]);
  const [orderDetail, setOrderDetail] = useState(null);
  const [orderDetailId, setOrderDetailId] = useState(null);
  const [isRefreshingMyAccount, setIsRefreshingMyAccount] = useState(false);

  const fetchUserData = useCallback(async () => {
    if (!user?.token) return;
    try {
      const response = await sendRequest(
        API_URLS.MY_ACCOUNT,
        "POST",
        JSON.stringify({
          token: user.token,
        }),
        DEFAULT_HEADERS.JSON_WITH_CORS
      );
      if (response.data) {
        setUserData(response.data.my_account);
        setCompanyData(response.data.company_data);
        setContactTerra(response.data.terra_contact);
        setCollaborators(response.data.company_users);
        setOrderHistory(response.data.order_history);
        setPaymentDelivery(response.data.payment_and_delivery);
        setOrderTargetCompanies(response.data.order_target_companies || []);
      }
    } catch (error) {
      handleApiError(error, { context: "MyAccountContext.fetchUserData", showToast: false });
    }
  }, [sendRequest, user?.token]);

  const refreshMyAccount = useCallback(async () => {
    if (!user) return;
    setIsRefreshingMyAccount(true);
    try {
      await fetchUserData();
    } finally {
      setIsRefreshingMyAccount(false);
    }
  }, [fetchUserData, user]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const loadOrderDetail = useCallback(async (id) => {

    const response = await sendRequest(
      `https://matrixterra.com.br/ws/customer/details_order.php?id_order=${id}`,
      "GET",
      null,
      {
        "Content-Type": "application/json",
        "Access-Control-Request-Method": "application/postscript",
      }
    );

    if (response.order) {
      setOrderDetail(response.order);
    } else {

      throw new Error(response.message);
    };

  }, []);

  useEffect(() => {

    if (orderDetailId) {

      loadOrderDetail(orderDetailId);

    };

  }, [loadOrderDetail, orderDetailId]);

  return (
    <MyAccountContext.Provider
      value={{
        userData,
        companyData,
        contactTerra,
        collaborators,
        orderHistory,
        paymentDelivery,
        orderTargetCompanies,
        setOrderDetailId,
        orderDetail,
        refreshMyAccount,
        isRefreshingMyAccount,
      }}
    >
      {children}
    </MyAccountContext.Provider>
  );
};
